<script>
    export let location;
</script>

<div class="flex flex-col items-center justify-center">
    <div>
        <img class="w-[200px] h-[200px] rounded-lg" src="logo.png" alt="Logo" />
    </div>
    <div class="text-3xl font-bold text-black dark:text-white">Qubyt</div>
    <div class="flex items-center justify-center w-1/2">
        <p class="text-black text-center dark:text-white">
            I am a software engineer who enjoys programming in many different languages and on many different projects.
        </p>
    </div>
</div>

<div class="flex flex-row justify-center md:flex-row">
    <a
        href="https://gitlab.com/jchand99"
        class="px-6 py-2 text-2xl font-bold text-black cursor-pointer rounded-md dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
        ><i class="lab la-gitlab text-orange-500" /></a
    >
    <a
        href="https://www.youtube.com/channel/UCfcij6KxJV4d-tMzXCBdyLg"
        class="px-6 py-2 text-2xl font-bold text-black cursor-pointer rounded-md dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
        ><i class="lab la-youtube text-red-500" /></a
    >
    <a
        href="https://www.twitch.tv/qubyts"
        class="px-6 py-2 text-2xl font-bold text-black cursor-pointer rounded-md dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
        ><i class="lab la-twitch text-purple-500" /></a
    >
</div>
